export default __webpack_public_path__ + "static/media/Signatria.752b1acd.ttf";